export enum RequestUpdateEntity {
	Assignee = 1,
	Vendor = 2
}
